export var PIGGY_BANK_EVENT_TYPES = {
  ENTER_PIGGY_BANK_SCREEN: 'ENTER_PIGGY_BANK_SCREEN',
  EXIT_PIGGY_BANK_SCREEN: 'EXIT_PIGGY_BANK_SCREEN',
  SHOW_PIGGY_BANK_TOOLTIP: 'SHOW_PIGGY_BANK_TOOLTIP',
  PIGGY_BANK_WIDGET_CLICK: 'PIGGY_BANK_WIDGET_CLICK',
  PIGGY_BANK_DISPLAY_TUTORIAL: 'PIGGY_BANK_DISPLAY_TUTORIAL',
  PIGGY_BANK_SKIP_TUTORIAL: 'PIGGY_BANK_SKIP_TUTORIAL',
  PIGGY_BANK_FINISH_TUTORIAL: 'PIGGY_BANK_FINISH_TUTORIAL'
};